<template>
  <div class="dropdown-wrapper" :class="[{'form-style': formStyle}]">
      <sprite class="input-icon" :name="spriteName" v-if="spriteName" />
      <p
        v-if="iconText"
        class="icon-text"
        >{{ iconText }}</p>
      <div class="dropdown-wrap"
        v-click-outside="closeDropdown"
      >
        <div class="dropdown" :class="[{'form-style': formStyle}]">
          <selected-items-multiselect
            v-if="value && multiselect"
            v-model="value"
            :formStyle="formStyle"
          />
          <div 
            v-if="!formStyle"
            class="input_wrapper"
            @click="showDropdown">
            <input 
              type="search"
              v-model="searchTerm"
              :disabled="disableSearch"
              :placeholder="placeholder ? placeholder : 'Search'"
              :isRequired="isRequired"
              @keyup="showDropdown"
              @keyup.esc="closeDropdown"
              @keyup.enter="selectItem"
              @keyup.up="selectUp"
              @keyup.down="selectDown"
              @keydown.up.prevent
              @keydown.down.prevent
              ref="input">
            <sprite
              v-if="!disableSearch"
              @click.native="clearSearchTerm"
              class="clear-icon"
              name="close" />
            <sprite
            v-if="disableSearch"
            @click.native="clearSearchTerm"
            class="clear-icon"
            name="arrow_drop_down" />
          </div>
        <div
          @click="showDropdown"
          v-if="formStyle">
          <rp-textinput
            autocomlete="off"
            v-model="searchTerm"
            :placeholder="placeholder ? placeholder : 'Search'"
            :isRequired="isRequired"
            :multiselect="multiselect"
            ref="input" />
        </div>

        </div>
        <dropdown-list
          v-model="filters"
          :hasFocus="hasFocus"
          :scrollable="scrollable"
          :hoveredItem="hoveredItem"
          @setHoverItem="setHoverItem"
          :formStyle="formStyle"
          ref="dropdown-list" />
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import Sprite from '../../../../components/ui/Sprite'
import Selected from './Selected'
import DropdownList from './DropdownList'
import TextInput from '../../../../components/ui/inputs/TextInput'

export default {
  components: {
    'sprite': Sprite,
    'selected-items-multiselect': Selected,
    'dropdown-list': DropdownList,
    'rp-textinput': TextInput
  },

  props: {
      value: [Object, Array, String],
      dataModel: [Object, Array, String],
      objectLabel: String,
      emitPath: String,
      spriteName: String,
      placeholder: String,
      multiselect: Boolean,
      scrollable: Boolean,
      disableSearch: Boolean,
      formStyle: Boolean,
      iconText: String,
      isRequired: Boolean
    },

    data() {
      return {
        content: this.value,
        hasFocus: false,
        searchTerm: "",
        result: [],
        hoveredItem: "",
        isIgnoreSearchTermIfSelected: false,
        isToggleEventActive: false,
      }
    },

    created () {
      
      if(this.multiselect) {
        const unwatch = this.$watch('value', function() {
            if(this.value) {
              unwatch()
              this.result = []
              this.value.forEach((item) => {
                this.toggleSelectedItem(item)
              })
            }
          })
        }
    },

    methods: {
      emitInput() {
        this.$emit('input', this.result)
      },

      getLabel(item) {
        return this.objectLabel ? item[this.objectLabel] : item
      },

      showDropdown() {
        this.hasFocus = true
      },

      closeDropdown() {
        this.hoveredItem = ""
        this.hasFocus = false
      },

      toggleSelectedItem(listItem) {  
        if(this.multiselect) {
          this.result.push(listItem)
        } else {
          this.result = listItem
          this.searchTerm = this.getLabel(listItem)
          this.isIgnoreSearchTermIfSelected = true
          this.isToggleEventActive = true
          this.closeDropdown()
        }

        this.$refs.input.focus()
        this.emitInput()
        
      },

      removeSelectedItem(listItem) {
        if(this.multiselect) {
          this.result.forEach((item, index) => {
            if(listItem === item) {
              this.result.splice(index, 1)
            }
          })
        } else {
          this.result = []
        }
        this.emitInput()
      },

      selectItem() {
        this.hoveredItem ? this.toggleSelectedItem(this.hoveredItem) : this.toggleSelectedItem(this.filters[0]) 
        this.closeDropdown()
      },

      setHoverItem(event) {
        if(event) {
          this.hoveredItem = event
        }
      },

      selectUp() {
        let hoveredElIndex = this.filters.indexOf(this.hoveredItem)
        let index = hoveredElIndex < 1 ? this.filters.length : hoveredElIndex
        this.$refs['dropdown-list'].setHoveredItem(this.filters[index-1], index-1)
      },

      selectDown() {
        let index = (this.filters.indexOf(this.hoveredItem) + 1) % this.filters.length
        this.$refs['dropdown-list'].setHoveredItem(this.filters[index], index)
      },

      setSearchTerm(term) {
        this.searchTerm = term
      },

      clearSearchTerm() {
        this.searchTerm = ""
      },

      isSearchTermFound(label) {
        return label.toLowerCase().includes(this.searchTerm.toLowerCase())
      },

      getNoResultItem() {
        if(this.objectLabel) {
            let noResult = {}
            noResult[this.objectLabel] = "No result"
            noResult["noResult"] = true
            return noResult
        } else {
          return "No result"
        }
      }
    },

    computed: {
      filters() {
        let filter = []
        
        this.dataModel.forEach((item) => {
          const label = this.getLabel(item)  
          if(this.multiselect) {
            if(!this.result.includes(item)) {
                if(this.isSearchTermFound(label)) {
                  filter.push(item)
                }
            }
          } else {
            if( this.isSearchTermFound(label) || this.isIgnoreSearchTermIfSelected) {
              filter.push(item)
            }
          }
        })

        if(!filter.length) {
          //for the case where this.filter is not yet cached
          if(this.filter)
            filter.push(this.getNoResultItem())
        } else {
          this.setHoverItem(this.searchTerm ? filter[0] : "")
        }
        
        return filter
      }
    },

    watch: {
      searchTerm(newVal, oldVal) {
        if(!this.multiselect) {
          //the watch happens after toggle function which reset isIgnoreSearchTermIfSelected
          if(!this.isToggleEventActive) {
            this.isIgnoreSearchTermIfSelected = false
          }
          this.isToggleEventActive = false
        }
      }
    },

    directives: {ClickOutside}
}
</script>

<style lang="sass" scoped>
@import '../../../../styles/base/variables'

.dropdown-wrapper
  display: flex
  flex-direction: row
  width: inherit

  .input-icon
    width: 20px
    height: 20px
    fill: $color-input-icon
    margin: 5px 10px 0px 0px

  .icon-text
    white-space: nowrap
    margin: auto
    margin-right: 10px
    font-size: 1rem

  .dropdown-wrap
    width: 100%


    .dropdown
      display: flex
      flex-direction: column
      background: white

      &.form-style
        background: transparent

      .input_wrapper
        display: flex
        align-items: center
        position: relative

        input
          height: 32px
          padding: 8px 20px 8px 8px
          width: 100%
          border: none
          color: $color-text

          &:focus
            outline: none

          &:disabled
            background-color: transparent
            border: 1px solid $color-border-lighter

        .clear-icon
          position: absolute
          max-width: 20px
          max-height: 30px
          padding: 4px
          right: 0
          fill: #939a9b

          &:hover
            cursor: pointer
            fill: $color-primary


</style>


// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/inputs/dropdown/Dropdown.vue